const mttOverlayTriggers = document.querySelectorAll(".js-mtt-overlay-trigger");

if (typeof mttOverlayTriggers != "undefined" && mttOverlayTriggers != null && mttOverlayTriggers.length > 0) {
    
    const mttOverlay = document.querySelector(".js-mtt-overlay");
    const closeButtons = document.querySelectorAll(".js-mtt-overlay-close");
    const contentContainers = document.querySelectorAll(".js-mtt-overlay-content")

    function toggleOverlay() {
        mttOverlay.classList.toggle("is-active");
        body.classList.toggle("stop-scrolling");
        if(!mttOverlay.classList.contains("is-active")) {
            contentContainers.forEach(content => {
                content.classList.remove("is-active");
            })
        }
    }

    function showContent() {
        let currentIndex = this.dataset.index;
        contentContainers.forEach(content => {
            let contentIndex = content.dataset.index;
            if(currentIndex == contentIndex) {
                content.classList.add("is-active")
            }
        });
    }

    for(let i = 0; i < mttOverlayTriggers.length; i++) {
        mttOverlayTriggers[i].addEventListener('click', toggleOverlay);  
        mttOverlayTriggers[i].addEventListener('click', showContent);   
    }

    for(let i = 0; i < closeButtons.length; i++) {
        closeButtons[i].addEventListener('click', toggleOverlay);   
    }

    mttOverlay.addEventListener('click', function(e) {
            if(e.target.classList.contains('mtt-overlay')) {
                toggleOverlay();
            }
    });
}